var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-table-action-wrapper"},[(_vm.readonly === null || _vm.readonly !== true)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }